export const aIAssistantOpenWithNoContent = '[AI Assist] Content generation';
export const aIAssistantOpenWithContent = '[AI Assist] Content enhancement';
export const aIAssistantCloseWithNoContent = '[AI Assist] Close modal';
export const aIAssistantAddMessageToCompose = '[AI Assist] Add content';
export const aIAssistantReplaceMessageToCompose = '[AI Assist] Replace content';
